export default "/images/logo.png?86e6194ab57cf5c408e347dbe4aa21f4";